// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"displayNavigation_wrapper__2iRzP","bottomLine":"displayNavigation_bottomLine__2rq3S","link":"displayNavigation_link__3nHCN","arrow":"displayNavigation_arrow__2jwWb"};